import Link from "@components/Link";
import clsx from "clsx";

type DropdownItem = {
  label: string;
  href: string;
};

type CategoryDropdownProps = {
  isDark?: boolean;
  items?: DropdownItem[];
  currentPath?: string;
};

export default function CategoryDropdown({
  isDark = false,
  items,
  currentPath = "",
}: CategoryDropdownProps) {
  if (!items || items.length === 0) return null;

  const textColor = isDark ? "text-primary-on-dark" : "text-primary";
  const bgColor = isDark
    ? "bg-background-secondary-on-dark"
    : "bg-background-secondary";

  return (
    <div
      className={clsx(
        "absolute top-full left-0 z-100 hidden pt-[10px] lg:block",
        "invisible opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100",
      )}
      data-testid="category-dropdown"
    >
      <div
        className={clsx(
          "flex flex-col items-start",
          "rounded-lg px-3 py-4",
          "border-divider-secondary border",
          "shadow-[0px_5px_12px_0px_rgba(0,0,0,0.1)]",
          "min-w-[200px] whitespace-nowrap",
          bgColor,
        )}
      >
        {items.map((item) => {
          const isActive = currentPath === item.href;
          return (
            <Link
              key={item.href}
              to={item.href}
              className="flex h-10 w-full items-center rounded px-3 py-0"
            >
              <p
                className={clsx(
                  "text-button-1 hover:text-brand-primary shrink-0 transition-colors",
                  textColor,
                  isActive && "text-brand-primary",
                )}
              >
                {item.label}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
